import { Button } from "components"

const CustomEmptyState = ({
  onClick,
  imageUrl,
  title,
  top,
  showIcon = true,
}: {
  onClick: () => void
  imageUrl: string
  title: string
  top?: string
  showIcon?: boolean
}) => {
  return (
    <div className="relative w-full h-full">
      <img
        src={imageUrl}
        className="w-full h-full"
      />

      <div
        className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 h-10"
        style={{ top: `${top ?? 82}%` }}
      >
        <Button
          className="h-10 border-2 border-[#004AF5] text-[#004AF5]"
          onClick={onClick}
        >
          {showIcon && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>
          )}
          {title}
        </Button>
      </div>
    </div>
  )
}
export default CustomEmptyState
